import { useEffect, useState, useCallback, useRef } from 'react';
import { useClientId } from "../context/context.js";
import * as helpers from "../utils/utils.js";

export function useCalendarSelections() {
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);

  const clearSlots = () => {
    setSelectedSlots([]);
  };

  const removeSlot = ({ slotId, date, unitId }) => {
    setSelectedSlots((prevSlots) =>
      prevSlots.filter((slot) => {
        if (slotId) return slot.id !== slotId;
        if (date && unitId) return !(slot.date === date && slot.unitId === unitId);
        return true;
      })
    );
  };

  const addSlot = (slot) => {
    setSelectedSlots((prevSlots) => [...prevSlots, slot]);
  };

  const clearDates = () => {
    setSelectedDates([]);
    setSelectedSlots([]);
  };

  const removeDate = (date) => {
    setSelectedSlots((prevSlots) => prevSlots.filter((slot) => slot.date !== date));
    setSelectedDates((prevDates) => prevDates.filter((d) => d !== date));
  };

  const addDate = (date) => {
    setSelectedDates((prevDates) => {
      const updatedDates = [...prevDates, date];
      updatedDates.sort();
      return updatedDates;
    });
  };

  return {
    addSlot,
    removeSlot,
    clearSlots,
    addDate,
    removeDate,
    clearDates,
    selectedDates,
    selectedSlots,
  };
}

